import React, { ReactNode } from "react";
import { UserProvider } from "../context/UserManager";
import UserDataFetcher from "../context/UserDataFetcher";
import { DeveloperModeProvider } from "../context/DeveloperModeContext";
import { DemoModeProvider } from "../context/DemoModeProvider";
import { ScannerProvider } from "../context/ScannerContext";
import { PrimaryFetchedDataProvider } from "../context/PrimaryFetchedDataContext";
import { UserControlsProvider } from "../context/UserControlsProvider";
import GlobalSnackbar from "../components/GlobalSnackbar/GlobalSnackbar";
import OfflineStatusBanner from "../components/OfflineStatusBanner/OfflineStatusBanner";
import RoleStatusBanner from "../components/RoleStatusBanner/RoleStatusBanner";
import UsersDataFetcher from "./UsersDataFetcher";
import TrucksDataProvider from "./TrucksDataProvider";
import { ThemesProvider } from "./ThemesProvider";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ShipmentManagerProvider } from "./ShipmentManagerProvider";
import { OfflineSyncProvider } from "./OfflineSyncProvider";

// Export CustomThemeType for use in ThemesProvider
export interface CustomThemeType {
  brand: string;
  accent: string;
  brandContrast: string;
  accentContrast: string;
  foreground: string;
  textSecondary: string;
  background: string;
  mainBackground: string;
  ctaColor: string;
  ctaContrast: string;
  hoverColor: string;
  dividerColor: string;
  error: string;
}

export const Providers: React.FC<{ children: ReactNode }> = ({ children }) => {
  console.log("[Providers] Rendering provider tree");
  return (
    <ThemesProvider>
      <OfflineSyncProvider>
        <OfflineStatusBanner />
        <RoleStatusBanner />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ScannerProvider>
            <UserProvider>
              <UserDataFetcher>
                <ShipmentManagerProvider>
                  <PrimaryFetchedDataProvider>
                    <UserControlsProvider>
                      <DemoModeProvider>
                        <UsersDataFetcher>
                          <TrucksDataProvider>
                            <DeveloperModeProvider>
                              {children}
                            </DeveloperModeProvider>
                          </TrucksDataProvider>
                          <GlobalSnackbar />
                        </UsersDataFetcher>
                      </DemoModeProvider>
                    </UserControlsProvider>
                  </PrimaryFetchedDataProvider>
                </ShipmentManagerProvider>
              </UserDataFetcher>
            </UserProvider>
          </ScannerProvider>
        </LocalizationProvider>
      </OfflineSyncProvider>
    </ThemesProvider>
  );
};
